import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { MaskLines, Overline, FadeUp } from "@/components/motion";
import { SermonCard } from "@/components/SermonCard";
import { useLang } from "@/context/LangContext";

export const Featured = () => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/sermons").then((r) => setItems(Array.isArray(r.data) ? r.data.slice(0, 3) : [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section data-testid="featured-sermons" className="mx-auto max-w-[1400px] px-5 py-24 md:px-10">
      <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <Overline>{t("featured.over")}</Overline>
          <MaskLines lines={[t("featured.title")]} className="font-display mt-5 text-5xl font-semibold text-[#F4EEE2] md:text-6xl" />
        </div>
        <FadeUp>
          <Link to="/sermons" data-testid="featured-all-link" className="group flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-5 py-3 font-ui text-sm font-semibold text-[#F4EEE2] transition-colors hover:bg-[#D4AF37] hover:text-[#0B111E]">
            {t("featured.all")} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </FadeUp>
      </div>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((s, i) => <SermonCard key={s.id} s={s} index={i} />)}
      </div>
    </section>
  );
};
